module.exports = __webpack_public_path__ + "media/images/lp/ashinagasan-ad1/icon_number01-1c7f41416e8ab852a98e02d33c592cb9.png";